import { defineMessages } from 'react-intl';

export default defineMessages({
	intro: {
		id: 'optout.intro',
		defaultMessage:
			'We use cookies and similar tracking technologies, and we allow our advertising partners to use such technologies, so we can, among other things, show you ads promoting Calm on other sites and services. We may also share your email address in a de-identified format to target you with ads on other websites or for similar purposes. These activities may be considered “sales,” “sharing,” or “targeted advertising” under certain privacy laws, and you may have the right to opt out. Below we provide instructions on how to opt out.',
		description: 'Intro text for opt out',
	},
	cookiesTitle: {
		id: 'optout.cookiesTitle',
		defaultMessage: 'Cookies',
		description: 'Title text for cookies section of opt out',
	},
	cookies: {
		id: 'optout.cookies',
		defaultMessage:
			'To opt-out of these activities on Calm’s website, click the “Opt Out of Targeting Cookies” button. Note that you will need to renew this opt-out choice if you visit our website from another device or browser or if you clear your cookies. You can also opt out by visiting our website with a legally-recognized opt-out preference signal, such as the Global Privacy Control.',
		description: 'Paragraph text for cookies section of opt out',
	},
	optOutOfTargetingCookiesCta: {
		id: 'optout.optOutOfTargetingCookiesCta',
		defaultMessage: 'Opt Out of Targeting Cookies',
		description: 'CTA that opts user out of targeting cookies',
	},
	optOutOfTargetingCookiesSuccess: {
		id: 'optout.optOutOfTargetingCookiesSuccess',
		defaultMessage: 'Opt Out Successful',
		description: 'Text shown to the user if they successfully opt out of targeting cookies',
	},
	mobileAppTitle: {
		id: 'optout.mobileAppTitle',
		defaultMessage: 'Mobile App',
		description: 'Title text for mobile app section of opt out',
	},
	mobileApp: {
		id: 'optout.mobileApp',
		defaultMessage:
			'If you use the Calm app and have a Calm account, you may opt out by following the instructions under “Account Information” below. If you do not have a Calm account, you may opt out by using your device settings. Specifically, on iOS devices, visit Settings > Privacy & Security > Tracking > Allow Apps to Request to Track. On Android devices, visit Settings > Google > Ads > Opt out of Ads Personalization.',
		description: 'Paragraph text for mobile app section of opt out',
	},
	accountInformationTitle: {
		id: 'optout.accountInformationTitle',
		defaultMessage: 'Account Information',
		description: 'Title text for account information section of opt out',
	},
	accountInformation: {
		id: 'optout.accountInformation2',
		defaultMessage:
			'We may disclose certain personal information tied to your Calm account (or that you have provided to us), such as your email address (in a way that doesn’t identify you directly) in order to promote Calm on other sites and services. To opt out, provide your email address in the form below.',
		description: 'Paragraph text for account information section of opt out',
	},
	submitCta: {
		id: 'optout.submitCta',
		defaultMessage: 'Submit',
		description: 'CTA that submits the form for user to request ad opt out',
	},
	submitSuccess: {
		id: 'optout.submitSuccess1',
		defaultMessage: 'Email Sent',
		description: 'Button text shown to the user if they successfully submit ad opt out request',
	},
	submitError: {
		id: 'optout.submitError',
		defaultMessage: 'Error Sending Request',
		description: 'Button text shown to the user if there is an error when submitting ad opt out request',
	},
	submitSuccessInformation: {
		id: 'optout.submitSuccessInformation',
		defaultMessage:
			'Thank you for your opt-out inquiry. You will receive an email to confirm your request if we find a matching user in our system. Please see our <externallink></externallink> to learn more about Calm’s privacy practices.',
		description: 'Info text shown to the user if they successfully submit ad opt out request',
	},
	privacyLinkText: {
		id: 'optout.privacyLinkText',
		defaultMessage: 'Privacy Policy',
		description: 'Text shown for the link to Calm Privacy Policy',
	},
});
